import "graveyard/build_profiles/invoca_app";
import "graveyard/build_profiles/management_app";

import "sparks/invoca_app";
import "sparks/invoca_sync";
import "sparks/action_table";
import "sparks/controls";
import "sparks/renderers";
import "sparks/form";
import "sparks/panel";
import "sparks/modal_dialog";

import Backdraft from "backdraft-app/src/backdraft";
import App from "backdraft-app/src/app";

class FileUploadApp extends App {
  constructor() {
    super(["InvocaApp", "DataTable", "InvocaSync", "ActionTable", "Controls", "Renderers", "Form", "Panel", "ModalDialog"]);
  }
}

const app = new FileUploadApp();

export default Backdraft.app("Shared/FileUpload", app);
